import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import { reduce, get, values } from 'lodash';
import { ProjectsModalFlow } from '../flow-projects/projects-modal';
import { CommentModal } from '../flow-projects/project-modal-comment';
import ModalManager from '../elements-modal/modal-manager';
import { ListingWrapper } from '../partials-thumbnails/listing-wrapper';
import Projects from '../../../api/api-projects';
import { Avatar } from 'shared-components/image/avatar';
import { Helpers } from 'shared-components/helpers/helpers';
import ListingThumbnail from 'shared-components/listing-thumbnail/ListingThumbnail';
import { Tooltip } from '../elements-tooltip/tooltip-v2';
import { FormattedMessage, injectIntl } from 'react-intl';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';

class ProjectListings extends Component {
  constructor (props) {
    super(props);

    this.renderListingThumb = this.renderListingThumb.bind(this);
    this.openHeartModal = this.openHeartModal.bind(this);
    this.listingsList = this.listingsList.bind(this);
    this.listSave = this.listSave.bind(this);
    this.createSave = this.createSave.bind(this);
    this.listSaveCallback = this.listSaveCallback.bind(this);
    this.createSaveCallback = this.createSaveCallback.bind(this);
    this.renderActivityButton = this.renderActivityButton.bind(this);
    this.renderCollaboratorList = this.renderCollaboratorList.bind(this);
    this.voteAction = this.voteAction.bind(this);
    this.commentAction = this.commentAction.bind(this);
    this.getVoteID = this.getVoteID.bind(this);
    this.closeCommentModal = this.closeCommentModal.bind(this);
    this.renderEditDescriptionButton = this.renderEditDescriptionButton.bind(this);
    this.handleHeartClick = this.handleHeartClick.bind(this);

    this.state = {
      showFirstTimeInfo: false,
      collaborators: [],
      listingModalID: '',
      hasMounted: false,
      isMobile: false
    };
  }

  componentDidMount () {
    const seenBoards = PSSessions.Cookies('board-1');
    const boarOwnderSSOID = _.get(this.props, ['project', 'created_by_sso_id'], '');
    if (!seenBoards && (boarOwnderSSOID !== PSSessions.Cookies.get('PSUser'))) {
      PSSessions.Cookies.set('board-1', true, { path: '/boards/' });
      this.setState({ showFirstTimeInfo: true });
    }
    this.setState({
      hasMounted: true,
      isMobile: Helpers.isMobile()
    });
  }

  componentWillUnmount() {
    // changing body scrolling behavior back to default when not on page
    if(this.state.isMobile){
      document.body.style.overflowY = 'visible';
    }
  }

  createSaveCallback (res, setModalBody) {
    const { resetErrorMessage } = this.props;
    const { body: { project } } = res;

    resetErrorMessage();

    const newProject = project;
    setModalBody({ modalType: 'success', newProject });
    this.props.fetchFavedListings();
  }

  listSaveCallback (res, modalCb) {
    this.props.fetchFavedListings();
    if (modalCb) return modalCb(res);
    this.props.closeModal();
  }

  listSave (payload, callback) {
    const { accessToken, batchUpdateAttachments } = this.props;

    batchUpdateAttachments(accessToken, payload)
      .then(callback)
      .catch(callback);
  }

  createSave (payload, callback) {
    const { accessToken, postProject } = this.props;
    postProject(accessToken, payload)
      .then(callback)
      .catch(callback);
  }

  openHeartModal (e, listing, previousState) {
    if (e) {
      e.preventDefault();
    }

    const { projects } = this.props;
    const modalProps = Object.assign({}, this.props, {
      listing,
      projects: values(projects)
    });

    ReactDOM.render(
      <SharedIntlProviderHOC>
        <ProjectsModalFlow
          { ...modalProps }
          modalType={previousState ? 'create' : 'list'}
          openModal={ this.openHeartModal }
          previousState={ previousState }
          listSave={ this.listSave }
          listSaveCallback={ this.listSaveCallback }
          createSave={ this.createSave }
          createSaveCallback={ this.createSaveCallback }
          analyticsOrigin={ 'save board thumbnail' }
          closeModal={this.props.closeModal}
        />
      </SharedIntlProviderHOC>,
      document.getElementById('modal-container')
    );
  }

  listingsList () {
    const { listings } = this.props;
    if (!listings.length) {
      return null;
    }

    const favoritedListObj =
      reduce(get(this.props, ['profile', 'favoritedListings'], {}),
        (acc, faved) => {
          acc[faved.value] = true;
          return acc;
        }, {});

    return (
      <div className='project-listings-thumbs-container'>
        {
          listings.map((listing, i) => {
            if (listing) {
              return this.renderListingThumb(listing, i, favoritedListObj);
            }

            return null;
          })
        }
      </div>
    );
  }

  getCollabList (ns, attachmentID, tooltipHelpers, listingID, index) {
    const { accessToken, collaborators } = this.props;
    const path = `ns=${ns}&value=${attachmentID}`;
    const optionalObj = {
      source: 'vote tooltip',
      flow_version: 'lite',
      app: 'web',
      label: 'vote tooltip',
      method: 'email',
      page: 'boards'
    };
    const signupAnalytics = () => {
      return this.props.votingCommentingAnalytics('signup form viewed', listingID, 'vote tooltip', index, optionalObj);
    };
    this.props.checkCredentials(() => {
      Projects.queryAttachments(path, accessToken, (res) => {
        if (res.error || 400 < res.statusCode) {
          // what to do if errors?
          console.log(res.error);
        }
        const attachments = _.get(res, ['attachments'], []);
        const collabsBySSOid = _.keyBy(collaborators, 'SSOid');
        const attachmentsWithProfile = _.reduce(attachments, (acc, val) => {
          const collabVal = val;
          collabVal.profile = collabsBySSOid[val.created_by_sso_id];
          acc.push(collabVal);
          return acc;
        }, []);
        this.props.votingCommentingAnalytics('board vote list viewed', listingID, 'vote tooltip', index);
        return this.setState({ collaborators: attachmentsWithProfile }, () => {
          const { open: isTooltipOpen, showTooltip } = tooltipHelpers;
          showTooltip(!isTooltipOpen);
        });
      });
    }, signupAnalytics, 'vote tooltip', index, listingID, optionalObj);
  }

  voteAction (listingID, ns, listingIndex) {
    const optionalObj = {
      source: 'vote',
      flow_version: 'lite',
      app: 'web',
      label: 'vote',
      method: 'email',
      page: 'boards'
    };
    const signupAnalytics = () => {
      return this.props.votingCommentingAnalytics('signup form viewed', listingID, 'vote', listingIndex, optionalObj);
    };
    this.props.checkCredentials(() => {
      const voteId = this.getVoteID(listingID);
      this.props.voteListing(listingID, ns, voteId, listingIndex);
    }, signupAnalytics, ns, listingIndex, listingID, optionalObj);
  }

  commentAction (listingID, i) {
    const { checkCredentials, toggleModal } = this.props;
    const optionalObj = {
      source: 'comment',
      flow_version: 'lite',
      app: 'web',
      label: 'comment',
      method: 'email',
      page: 'boards'
    };
    const action = 'comment board thumbnail';
    const signupAnalytics = () => {
      return this.props.votingCommentingAnalytics('signup form viewed', listingID, action, i, optionalObj);
    };
    checkCredentials(() => {
      this.setState({ listingModalID: listingID },
        () => {
          toggleModal(`commentModal-${listingID}`);
          return this.props.votingCommentingAnalytics('board comment form viewed', listingID, action, i);
        }
      );
    }, signupAnalytics, action, i, listingID, optionalObj);
  }

  closeCommentModal () {
    this.setState({ listingModalID: '' });
  }

  renderCollaboratorList () {
    const { collaborators } = this.state;
    return (
      <ul className="list-unstyled" style={{ marginBottom: 0 }}>
        {
          collaborators.length ? collaborators.map((val) => {
            const profile = get(val, 'profile', {});
            const { first_name: firstName = '', last_name: lastName = '' } = profile;
            return (
              <li key={`collab-list=${val._id}`}>
                {`${firstName} ${lastName}`}
              </li>
            );
          }) : null
        }
      </ul>
    );
  }

  getVoteID (listingID) {
    const { attachments = [] } = this.props;
    const listingAttachment = attachments[listingID];
    const reqAttachments = listingAttachment.requester_attachments || {};
    return Object.keys(reqAttachments).filter((key) => {
      const ns = reqAttachments[key].ns;
      return 'DOWNVOTE' === ns || 'UPVOTE' === ns;
    })[0];
  }

  renderListingThumb (listing, i, favoritedListings) {
    const { _id: listingID } = listing;
    const { isMobile } = this.state;
    const { profile = {}, project = {}, attachments = [], userIsInvited } = this.props;
    const listingAttachment = attachments[listingID];
    const voteId = this.getVoteID(listingID);
    const voteType = get(attachments, [listingID, 'requester_attachments', voteId, 'ns'], '');

    const listingData = Object.assign({}, listing, {
      currency: listing['price.currency'],
      hourly_price: listing['price.hourly'],
      review_stars: listing.space_review_stars,
      review_count: listing.space_review_count,
      city: null,
      neighborhood: null
    });
    const downvotes = parseInt(listingAttachment.downvotes || 0, 10);
    const upvotes = parseInt(listingAttachment.upvotes || 0, 10);
    const attachmentID = listingAttachment._id;
    const projectOwnerProfile = get(project, ['created_by_profile'], {});
    const hostName = projectOwnerProfile.first_name
      ? `${projectOwnerProfile.first_name}`
      : this.props.intl.formatMessage({ id: 'boards.project_listings.owner_board', defaultMessage: 'the owner of this board' });

    const isTastemaker = !!project.tastemaker;
    const showUserInteractions = isTastemaker !== '' && userIsInvited;
    const isFirstThumbnail = 0 === i;
    const showFirstTimeTooltip = isFirstThumbnail && !isTastemaker && userIsInvited;

    const scrollContainer = isMobile ?  document.querySelector('body'): '.project-listings-container';

    if(isMobile){
      const bodyElement = document.body;
      if(bodyElement){
        bodyElement.style.overflowY = "auto";
      }
    }

    return (
      <div
        key={ listingID }
        ref={(node) => {
          this[`wrapperNode-${i}`] = node;
        }}
        className='listing-thumbnail-container'
      >
        <ListingWrapper>
          <ListingThumbnail
            listing={ listingData }
            listingURL={ `/pages/listings/${listingID}` }
            interaction={e => {
              e.preventDefault();
              this.handleHeartClick(listing);
            }}
            isSaved={ favoritedListings[listingID] }
            reviews
            swipeable
            source="boards thumbnail"
            scrollContainer={scrollContainer}
          />
          {
            showUserInteractions &&
              <div>
                <ul className="list-inline" style={{ marginBottom: 0 }}>
                  <li className="v-center">
                    <button
                      className="remove-click-styling"
                      onClick={e => {
                        e.preventDefault();
                        this.voteAction(listingID, 'UPVOTE', i);
                      }}
                      disabled={this.props.voteButtonDisabled ? 'disabled' : ''}
                      style={{ border: 'none', paddingLeft: 0, background: 'none' }}
                    >
                      <i
                        className={`ico ico-md icon-thumbs-up up-vote generic-btn ${'UPVOTE' === voteType ? 'text-green' : 'text-gray'}`}
                        style={{ verticalAlign: 'middle', fontSize: '20px' }}
                      />
                    </button>
                  </li>
                  <li className="v-center">
                    <Tooltip
                      placement="bottom"
                      id={`upvote-tooltip-${i}`}
                      tooltipClass="vote-cta"
                      parentNode={this[`wrapperNode-${i}`]}
                      anchorType="custom"
                      hideOnClickAnywhere
                      anchorClickCB={(tooltipHelpers) => {
                        this.getCollabList('UPVOTE', attachmentID, tooltipHelpers, listingID, i);
                      }}
                      customAnchor={
                        <button onClick="" disabled={0 === upvotes ? 'disabled' : ''} className={`btn v-center circle-number ${'UPVOTE' === voteType ? 'bg-green' : ''}`}>
                          { upvotes }
                        </button>
                      }
                    >
                      { this.renderCollaboratorList() }
                    </Tooltip>
                  </li>
                  <li className="v-center">
                    <button
                      className="remove-click-styling no-gutter-right"
                      onClick={e => {
                        e.preventDefault();
                        this.voteAction(listingID, 'DOWNVOTE', i);
                      }}
                      disabled={this.props.voteButtonDisabled ? 'disabled' : ''}
                      style={{ border: 'none', paddingLeft: 0, background: 'none' }}
                    >
                      <i
                        className={`ico ico-md icon-thumbs-down down-vote ${'DOWNVOTE' === voteType ? 'text-red' : 'text-gray'}`}
                        style={{ verticalAlign: 'middle', fontSize: '20px' }}
                      />
                    </button>
                  </li>
                  <li className="v-center">
                    <Tooltip
                      placement="bottom"
                      id={`downvote-tooltip-${i}`}
                      tooltipClass="vote-cta"
                      parentNode={this[`wrapperNode-${i}`]}
                      disabled={this.props.voteButtonDisabled ? 'disabled' : ''}
                      anchorType="custom"
                      hideOnClickAnywhere
                      anchorClickCB={(tooltipHelpers) => {
                        this.getCollabList('DOWNVOTE', attachmentID, tooltipHelpers, listingID, i);
                      }}
                      customAnchor={
                        <button onClick="" disabled={0 === downvotes ? 'disabled' : ''} className={`btn v-center circle-number ${'DOWNVOTE' === voteType ? 'bg-red' : ''}`}>
                          { downvotes }
                        </button>
                      }
                    >
                      { this.renderCollaboratorList() }
                    </Tooltip>
                  </li>
                  <li className="v-center" style={{ float: 'right', paddingRight: 0 }}>
                    <button
                      style={{ padding: 0 }}
                      className="btn btn-link remove-click-styling"
                      onClick={ e => {
                        e.preventDefault();
                        this.commentAction(listingID, i);
                      }}
                    >
                      <ul className="list-inline">
                        {
                          listingAttachment.comments && 0 < listingAttachment.comments ?
                            <li className="v-center" style={{ paddingRight: '0' }}>{listingAttachment.comments}</li>
                            : null
                        }
                        <li className="v-center hidden-md">
                          { 1 < listingAttachment.comments
                            ? <FormattedMessage id="boards.project_listings.comments" defaultMessage="Comments" />
                            : <FormattedMessage id="boards.project_listings.comment" defaultMessage="Comment" />
                          }
                        </li>
                        <li style={{ paddingRight: 0 }} className="v-center"><i className="icon-messages v-center" /></li>
                      </ul>
                    </button>
                  </li>
                </ul>
              </div>
          }
        </ListingWrapper>
        {
          this.state.listingModalID === listingID ?
            <ModalManager {...this.props}>
              <CommentModal
                ref={`commentModal-${listingID}`}
                listingAttachment={listingAttachment}
                index={i}
                votingCommentingAnalytics={this.props.votingCommentingAnalytics}
                attachmentDetail={this.props.attachmentDetail}
                onClose={this.closeCommentModal}
                inviteId={this.props.inviteId}
              />
            </ModalManager>
            : null
        }
        {
          (showFirstTimeTooltip) ?
            <div className="blue-tooltip">
              <Tooltip
                placement="bottom"
                id="new-user-tooltip"
                tooltipClass="new-user-tooltip blue-tooltip"
                managedByParentVal={this.state.showFirstTimeInfo}
                anchorType="none"
                arrowPlacement={{ top: -30 }}
                showX
                hideOnClickAnywhere={ false }
                closeCB={() => this.setState({ showFirstTimeInfo: false })}
                animation={ false }
              >
                <span>
                  <FormattedMessage
                    id="boards.project_listings.think_of_space"
                    defaultMessage="Let {name} know what you think of this space."
                    values={{
                      name: hostName
                    }}
                  />
                </span>
              </Tooltip>
            </div> : null
        }
      </div>
    );
  }

  handleHeartClick (listing) {
    this.props.checkCredentials(() => {
      const createModal = !get(this.props, ['profile', 'favoritedListings'], []).length;
      this.openHeartModal(null, listing, createModal);
    },
    this.props.signupAnalyticsAction,
    'signup');
  }

  renderEditDescriptionButton (text, type) {
    const { project } = this.props;
    const editDescription = 'edit' === type;
    return (
      <div style={{ float: editDescription ? 'left' : 'none', paddingTop: 8, paddingBottom: 8 }} onClick={() => { this.props.descriptionAnalytics('edit description') }}>
        <Link to={{ pathname: `/boards/${project.external_id}/settings` }} className={`remove-click-styling ${editDescription ? 'margin-md-top' : ''}`}>
          <div>{text}</div>
        </Link>
      </div>
    );
  }

  renderBoardDescription () {
    const { project, profile } = this.props;
    const isOwner = profile.SSOid === project.created_by_sso_id;
    const ownerProfile = project.created_by_profile || {};
    if (project.description || isOwner) {
      return (
        <div className="description-container padding-md margin-lg-bottom">
          { project.description ?
            <ul className="list-inline" style={{ marginBottom: 0 }}>
              <li className="v-center hidden-xs" style={{ width: '15%', margin: '8px 0' }}>
                <Avatar
                  src="/web-2/assets/images/no_avatar_placeholder.svg?v=rb"
                  id={ownerProfile.avatar_id}
                  maxWidth="73px"
                />
              </li>
              <li className="v-center board-description-text" style={{ paddingRight: 12, paddingLeft: 20 }}>
                <div>
                  <div style={{ paddingTop: 8, paddingBottom: isOwner ? 0 : 8 }}>{`"${project.description}"`}
                    <span className="heavy" style={{ color: '#4b4b4b', whiteSpace: 'nowrap' }}>{` - ${ownerProfile.first_name || ''} ${ownerProfile.last_name || ''}`}</span>
                  </div>
                  { isOwner ? this.renderEditDescriptionButton(this.props.intl.formatMessage({ id: 'boards.project_listings.edit_description', defaultMessage: 'Edit description' }), 'edit') : '' }
                </div>
              </li>
            </ul>
            : isOwner ?
              <div className="text-xs-center">
                {this.renderEditDescriptionButton(this.props.intl.formatMessage({ id: 'boards.project_listings.add_description', defaultMessage: '+ Add a description to your board' }))}
              </div> : '' }
        </div>
      );
    }
    return null;
  }

  renderListingCount () {
    const { listings, project } = this.props;
    const { activity } = project;

    if (!listings.length) {
      return null;
    }

    const listingsCount = listings.length;

    const renderActivity = () => {
      let activityName = '';
      if (activity) {
        activityName = activity.toLowerCase();
      }
      return (
        <FormattedMessage
          id="boards.project_listings.activity_spaces"
          defaultMessage="{activity} {spaces}"
          values={{
            activity: activityName,
            spaces: 1 < listingsCount
              ? <FormattedMessage id="boards.project_listings.spaces" defaultMessage="spaces" />
              : <FormattedMessage id="boards.project_listings.space" defaultMessage="space" />
          }}
        />
      );
    };

    return (
      <p className="text-gray-600" style={{ marginTop: '25px' }}>
        {listingsCount}
        {' '}
        {renderActivity()}
      </p>
    );
  }

  renderActivityButton () {
    const { project: { location }, activityData } = this.props;
    const urlPrefix = SharedIntlProviderHOC.getUrlPrefix();

    if (activityData && activityData.title && location) {
      const { id, title } = activityData;
      const locationString = location.replace(/\,\s/g, '--').replace(/\s/g, '-');
      const activityURL = `/s/?a=${id}&location=${locationString}`;
      const activityText = this.props.intl.formatMessage({ id: 'boards.project_listings.find_more_activity', defaultMessage: 'Find More {title} Spaces' }, { title: title });

      return (
        <div>
          <a href={ activityURL }>
            <button className="btn btn-lg btn-primary center-block">{ activityText }</button>
          </a>
        </div>
      );
    }

    return (
      <div>
        <a href={`/${urlPrefix}`}>
          <button className="btn btn-lg btn-primary center-block">
            <FormattedMessage id="boards.project_listings.find_more" defaultMessage="Find More Spaces" />
          </button>
        </a>
      </div>
    );
  }

  render () {
    return (
      <div id="results-thumbnails" className="project-thumbnails block-xs-center white-bg">
        { this.renderBoardDescription() }
        { this.renderListingCount() }
        { this.listingsList() }
        { this.renderActivityButton() }
      </div>
    );
  }
}

ProjectListings.propTypes = {
  accessToken: PropTypes.string,
  listings: PropTypes.array,
  profile: PropTypes.object,
  project: PropTypes.object,
  resetErrorMessage: PropTypes.func,
  batchUpdateAttachments: PropTypes.func,
  postProject: PropTypes.func,
  checkCredentials: PropTypes.func,
  activityData: PropTypes.object,
  closeModal: PropTypes.func,
  descriptionAnalytics: PropTypes.func
};

export default injectIntl(ProjectListings);
